import { render, staticRenderFns } from "./myadvantage.vue?vue&type=template&id=37a81db8&scoped=true"
import script from "./myadvantage.vue?vue&type=script&lang=js"
export * from "./myadvantage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a81db8",
  null
  
)

export default component.exports